// helpers
import { statusRecipes } from "../../utils/helpers";

// components
import AdminStatusItem from "./AdminStatusItem";
import UserLoading from "../Loading";

const AdminPending = ({ recipes, loading }) => {
  const pending = statusRecipes(recipes, "pending");

  return (
    <div className='admin-wrapper'>
      <h4 className='font-weight-bold'>Pending Recipes</h4>
      {loading ? (
        <div className='loading-wrapper'>
          <UserLoading />
        </div>
      ) : pending.length > 0 ? (
        pending.map((item, index) => {
          return <AdminStatusItem key={index} data={item} status='pending' />;
        })
      ) : (
        <div className='recipes-empty'>
          <h5>No recipes to show!</h5>
        </div>
      )}
    </div>
  );
};

export default AdminPending;
